import React from 'react';
import Modal from '../Modal';

export default function ResultOfSavingModal(props) {
  const { success, buttons, errorMessage } = props;
  return (
    <Modal
      isOpen
      title="User Properties"
      buttons={buttons}
    >
      {success ? (
        <div>
          Successfully updated.
        </div>
      ) : (
        <div>
          There was an error while updating user attributes:
          <br />
          {errorMessage}
          <br />
          Please try again.
        </div>
      )}
    </Modal>
  );
}
